import stylex from '@stylexjs/stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { typography } from '@shared/tokens/typography.stylex';

export const styles = stylex.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    fontFamily: fonts.din2014Regular,
    fontSize: '14px',
    lineHeight: '20px',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
    alignSelf: 'stretch',
    backgroundColor: {
      default: colors.brandGhostBackground,
      ':hover': colors.brandGhostHoverBackground,
    },
    borderRadius: '8px',
    padding: '12px 14px',
  },

  row: { display: 'flex', flexDirection: 'row', alignItems: 'center' },
  title: {
    paddingLeft: '8px',
  },

  rightRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '12px',
    height: '24px',
  },

  action: {
    cursor: 'pointer',
  },
  body: { display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', gap: '12px' },

  quantity: {
    fontFamily: 'DIN-2014_Regular',
    fontSize: typography['fontSizeCaption-2'],
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['fontSizeCaption-2'],
    color: colors.secondaryText,
  },
});
